var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getLogger, promiseTimeout, } from '@spotify-internal/remote-config-common';
import { KnownContext } from '@spotify-internal/remote-config-core';
import { Configuration } from '@spotify-internal/remote-config-properties';
const isConfigStorage = (x) => 'getConfig' in x;
export const cachingMiddleware = (next) => ({ clientId, storage = localStorage, cacheFactory, timeout: defaultTimeout, }) => {
    const logger = getLogger('middleware:caching');
    if (!storage)
        return next;
    const configStorage = getConfigStorage(storage, clientId, cacheFactory);
    return (_a) => __awaiter(void 0, void 0, void 0, function* () {
        var { timeout = defaultTimeout } = _a, req = __rest(_a, ["timeout"]);
        const key = KnownContext.hash(req);
        let cacheTimeout = Number.POSITIVE_INFINITY;
        if (typeof timeout === 'number') {
            cacheTimeout = timeout;
            timeout = Number.POSITIVE_INFINITY;
        }
        const pendingConfig = next(Object.assign({ timeout }, req));
        try {
            const cachedConfig = yield configStorage.getConfig(key);
            logger.info('cache %s for key %s', cachedConfig ? 'hit' : 'miss', key);
            if (cachedConfig)
                return Configuration.builder(cachedConfig);
        }
        catch (err) {
            logger.warn('Error reading from cache.', err);
        }
        finally {
            pendingConfig.then((config) => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    yield configStorage.setConfig(key, config);
                }
                catch (err) {
                    logger.error('Error writing to cache.', err);
                }
            }));
        }
        return promiseTimeout(pendingConfig, cacheTimeout);
    });
};
class SingleEntryConfigStorage {
    constructor(storageKey, storage) {
        this.storageKey = storageKey;
        this.storage = storage;
    }
    getConfig(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const entry = this.storage.getItem(this.storageKey);
            if (typeof entry === 'string') {
                const entryJson = JSON.parse(entry);
                if (entryJson.key === key)
                    return Configuration.fromJSON(entryJson.value);
            }
            return null;
        });
    }
    setConfig(key, config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.storage.setItem(this.storageKey, JSON.stringify({
                key,
                value: config.toJSON(),
            }));
        });
    }
}
function getConfigStorage(storage, clientId, cacheFactory) {
    if (isConfigStorage(storage) && !!cacheFactory) {
        throw new Error('[Remote-Configuration] Both storage as a cache and a cacheFactory supplied to Caching middleware, only one or the other is supported.');
    }
    if (isConfigStorage(storage)) {
        return storage;
    }
    if (cacheFactory) {
        return cacheFactory(storage, clientId);
    }
    return new SingleEntryConfigStorage(`com.spotify.single.item.cache:${clientId}`, storage);
}
//# sourceMappingURL=caching.js.map